module.exports = {
          srcSet: __webpack_public_path__ + "d03faf7b4b27c32a64a3397808973cc7-1376.png"+" 1376w",
          images:[ {path: __webpack_public_path__ + "d03faf7b4b27c32a64a3397808973cc7-1376.png",width: 1376,height: 104}],
          src: __webpack_public_path__ + "d03faf7b4b27c32a64a3397808973cc7-1376.png",
          toString:function(){return __webpack_public_path__ + "d03faf7b4b27c32a64a3397808973cc7-1376.png"},
          
          width: 1376,
          height: 104
        }